import AllUser from "./AllUser";

const AllDoctor = () => (
  <AllUser
    pageTitle="All Doctors"
    defaultType="1"
    defaultEmpType="3"
    hideTypeFilter
    hideEmployeeTypeFilter
  />
);

export default AllDoctor;
